define('controllers/fieldDate',[], function() {
    var controller = Marionette.Object.extend({

        initialize: function () {
            this.listenTo( nfRadio.channel( 'date' ), 'init:model', this.initModel );
            this.listenTo( nfRadio.channel( 'date' ), 'render:view', this.initDatepicker );

            // Register custom validation handlers for required fields
            nfRadio.channel( 'date' ).reply( 'validate:required', this.validateRequired, this );
            nfRadio.channel( 'date' ).reply( 'validate:modelData', this.validateModelData, this );

            // Listen to submit channel to see if validation is triggered for repeater fields
            this.listenTo( nfRadio.channel( 'submit' ), 'validate:field', this.onSubmitValidateField );

            // Listen to error events to add/remove error styling on hour/minute dropdowns
            this.listenTo( nfRadio.channel( 'fields' ), 'add:error', this.addErrorStyling );
            this.listenTo( nfRadio.channel( 'fields' ), 'remove:error', this.removeErrorStyling );

            this.isSubmitting = false;
            this.formListenersSet = {}; // Track which forms we've set up listeners for
        },

        onSubmitValidateField: function( model ) {
            // Only handle date fields
            if ( model.get( 'type' ) !== 'date' ) {
                return;
            }

            // Mirror validateRequired.js's own guard: an optional or hidden
            // field is never a validation candidate, regardless of its
            // date/time value. Without this, an empty optional field - or a
            // required field hidden via Conditional Logic - incorrectly
            // blocks submission with no visible field-level error (#8128).
            if ( 1 != model.get( 'required' ) || ! model.get( 'visible' ) ) {
                return;
            }

            // This event fires once per field for both a real form submit and
            // a multi-part "Next" click with "Validate each part" enabled -
            // both are a genuine validation attempt.
            //
            // validateRequired.js independently listens to this same event
            // and calls validateModelData() via a separate radio-channel
            // request. Which listener runs first (this one, vs that one) is
            // determined by controller registration order, which we don't
            // control - so for whichever field happens to be processed
            // first, that separate listener could run before isSubmitting is
            // set here, reading a stale "not submitting" state and wrongly
            // staying lenient. To avoid depending on that ordering, compute
            // and apply the verdict directly here rather than trusting the
            // other listener to see the flag in time.
            this.isSubmitting = true;

            var isValid = this.validateModelData( model );
            if ( 'undefined' !== typeof isValid ) {
                var formModel = nfRadio.channel( 'form-' + model.get( 'formID' ) ).request( 'get:form' );
                if ( 'undefined' !== typeof formModel ) {
                    if ( isValid ) {
                        nfRadio.channel( 'fields' ).request( 'remove:error', model.get( 'id' ), 'required-error' );
                    } else {
                        nfRadio.channel( 'fields' ).request( 'add:error', model.get( 'id' ), 'required-error', formModel.get( 'settings' ).validateRequiredField );
                    }
                }
            }

            var self = this;
            setTimeout( function() {
                self.isSubmitting = false;
            }, 100 );
        },

        addErrorStyling: function( model, errorID, errorMsg ) {
            // Only handle date fields
            if ( model.get( 'type' ) !== 'date' ) {
                return;
            }

            var dateMode = model.get( 'date_mode' );
            // Only add styling for time_only and date_and_time modes
            if ( dateMode === 'date_only' ) {
                return;
            }

            // Get the field ID and find the field container
            var fieldID = model.get( 'id' );
            var formID = model.get( 'formID' );


            // Try multiple selectors to find the field container
            var fieldContainer = jQuery( '[data-field-id="' + fieldID + '"]' );

            if ( fieldContainer.length === 0 ) {
                // Try with data-id instead
                fieldContainer = jQuery( '[data-id="' + fieldID + '"]' );
            }

            if ( fieldContainer.length === 0 ) {
                // Try finding by field key
                var fieldKey = model.get( 'key' );
                fieldContainer = jQuery( '[data-field-key="' + fieldKey + '"]' );
            }


            if ( fieldContainer.length > 0 ) {
                // Find hour and minute dropdowns - they should be within or near this container
                var hourSelect = fieldContainer.find( '.hour' );
                var minuteSelect = fieldContainer.find( '.minute' );

                // If not found within container, try the closest parent field wrapper
                if ( hourSelect.length === 0 ) {
                    var fieldWrap = fieldContainer.closest( '.nf-field' );
                    hourSelect = fieldWrap.find( '.hour' );
                    minuteSelect = fieldWrap.find( '.minute' );
                }


                // Add nf-error class and inline error styling to hour and minute dropdowns
                hourSelect.addClass( 'nf-error' ).css( 'border-color', '#d9534f' );
                minuteSelect.addClass( 'nf-error' ).css( 'border-color', '#d9534f' );
            } else {
            }
        },

        removeErrorStyling: function( model, errorID ) {
            // Only handle date fields
            if ( model.get( 'type' ) !== 'date' ) {
                return;
            }

            var dateMode = model.get( 'date_mode' );
            // Only remove styling for time_only and date_and_time modes
            if ( dateMode === 'date_only' ) {
                return;
            }

            // Check if there are any remaining errors on this field
            var errors = model.get( 'errors' );
            if ( errors && errors.length > 0 ) {
                // Still have errors, don't remove styling
                return;
            }

            // Get the field ID and find the field container
            var fieldID = model.get( 'id' );
            var formID = model.get( 'formID' );


            // Try multiple selectors to find the field container
            var fieldContainer = jQuery( '[data-field-id="' + fieldID + '"]' );

            if ( fieldContainer.length === 0 ) {
                // Try with data-id instead
                fieldContainer = jQuery( '[data-id="' + fieldID + '"]' );
            }

            if ( fieldContainer.length === 0 ) {
                // Try finding by field key
                var fieldKey = model.get( 'key' );
                fieldContainer = jQuery( '[data-field-key="' + fieldKey + '"]' );
            }

            if ( fieldContainer.length > 0 ) {
                // Find hour and minute dropdowns
                var hourSelect = fieldContainer.find( '.hour' );
                var minuteSelect = fieldContainer.find( '.minute' );

                // If not found within container, try the closest parent field wrapper
                if ( hourSelect.length === 0 ) {
                    var fieldWrap = fieldContainer.closest( '.nf-field' );
                    hourSelect = fieldWrap.find( '.hour' );
                    minuteSelect = fieldWrap.find( '.minute' );
                }

                // Remove nf-error class and inline error styling from hour and minute dropdowns
                hourSelect.removeClass( 'nf-error' ).css( 'border-color', '' );
                minuteSelect.removeClass( 'nf-error' ).css( 'border-color', '' );
            } else {
            }
        },

        beforeFormSubmit: function( formModel ) {
            this.isSubmitting = true;

            // Get the form ID
            var formID = formModel.get( 'id' );

            // Get repeater field models using the same method as fieldCollection.js
            var repeaterModels = nfRadio.channel( 'field-repeater' ).request( 'get:repeaterFieldsModelsArrayByForm', formID );

            if ( repeaterModels && repeaterModels.length > 0 ) {
                var self = this;
                _.each( repeaterModels, function( fieldModel ) {
                    var fieldID = fieldModel.get( 'id' );
                    var fieldType = fieldModel.get( 'type' );
                    var isRequired = fieldModel.get( 'required' ) == 1;
                    var isVisible = fieldModel.get( 'visible' );


                    // Only validate required, visible date fields
                    if ( fieldType === 'date' && isRequired && isVisible ) {

                        // Set clean to false to ensure validation runs
                        fieldModel.set( 'clean', false );

                        // Manually call our validation logic
                        var valid = self.validateModelData( fieldModel );


                        // If validateModelData returns undefined, it means use default validation
                        // For date_only mode, just check if value is not empty
                        if ( valid === undefined ) {
                            var value = fieldModel.get( 'value' );
                            var dateMode = fieldModel.get( 'date_mode' );
                            // Check if value is not empty
                            valid = value && String( value ).trim() !== '';
                        }

                        // Add or remove error based on validation result
                        if ( ! valid ) {
                            var errorMessage = formModel.get( 'settings' ).validateRequiredField;
                            nfRadio.channel( 'fields' ).request( 'add:error', fieldID, 'required-error', errorMessage );
                        } else {
                            nfRadio.channel( 'fields' ).request( 'remove:error', fieldID, 'required-error' );
                        }
                    }
                }, this );
            } else {
            }

            // Reset after a short delay to allow validation to run but return to field interaction mode
            var self = this;
            setTimeout( function() {
                self.isSubmitting = false;
            }, 100 );
        },

        afterFormSubmit: function() {
            this.isSubmitting = false;
        },

        initModel: function(model) {
            this.normalizeDateMode(model);
            this.registerFunctions(model);
        },

        /**
         * Default a missing date_mode to 'date_only'.
         *
         * The date_mode setting arrived in 3.14.10, so any Date field saved
         * before then has no value stored for it (and some saves persisted an
         * empty string). The render path already draws such a field as date
         * only, because it only adds hour/minute inputs for 'time_only' and
         * 'date_and_time', but every other check here compares strictly against
         * 'date_only' and so read the missing value as date-and-time, then
         * failed required validation on hour/minute inputs that were never
         * rendered. PHP already normalizes the same gap - see
         * Date::filter_merge_tag_value(). See #8112.
         *
         * This is a runtime default on the field model only. It is deliberately
         * not written back to the form, so the site's saved data is never
         * modified on a visitor's page view.
         */
        normalizeDateMode: function( model ) {
            if ( ! model.get( 'date_mode' ) ) {
                model.set( 'date_mode', 'date_only' );
            }
        },

        registerFunctions: function( model ) {
            model.set( 'renderHourOptions', this.renderHourOptions );
            model.set( 'renderMinuteOptions', this.renderMinuteOptions );
            model.set( 'maybeRenderAMPM', this.maybeRenderAMPM );
            model.set( 'customClasses', this.customClasses );
            // Overwrite the default getValue() method.
            model.getValue = this.getValue;
        },

        renderHourOptions: function() {
            return this.hours_options;
        },

        renderMinuteOptions: function() {
            return this.minutes_options;
        },

        maybeRenderAMPM: function() {
            if ( 'undefined' == typeof this.hours_24 || 1 == this.hours_24 ) {
                return;
            }
            var requiredAttr = (this.required == 1) ? 'aria-required="true" required' : '';
            var amLabel = nfi18n.am ? nfi18n.am : 'AM';
            var pmLabel = nfi18n.pm ? nfi18n.pm : 'PM';
            return `<div style="float:left;" class="time-wrap"><select id="ampm-select" class="ampm extra" aria-label="am-pm-select" ${requiredAttr}><option value="am">${amLabel}</option><option value="pm">${pmLabel}</option></select></div>`;
        },

        initDatepicker: function ( view ) {
            view.model.set( 'el', view.el );
            var el = jQuery( view.el ).find( '.nf-element' )[0];

            // Diagnostic logging for repeater fields
            var fieldID = view.model.get( 'id' );
            var fieldType = view.model.get( 'type' );
            var isRepeaterField = typeof fieldID === 'string' && fieldID.includes( '.' );

            view.listenTo( nfRadio.channel( 'form-' + view.model.get( 'formID' ) ), 'before:submit', this.beforeSubmit, view );

            // Set up form-level submit listeners for validation (once per form)
            var formID = view.model.get( 'formID' );
            if ( ! this.formListenersSet[ formID ] ) {
                this.listenTo( nfRadio.channel( 'form-' + formID ), 'before:submit', this.beforeFormSubmit );
                this.listenTo( nfRadio.channel( 'form-' + formID ), 'after:submit', this.afterFormSubmit );
                // Reset flag after validation completes (whether it passes or fails)
                this.listenTo( nfRadio.channel( 'form-' + formID ), 'submit:response', this.afterFormSubmit );
                this.formListenersSet[ formID ] = true;
            }

            // Ensure hour and minute dropdowns have placeholder options
            // This handles cases where fields were created before the placeholder fix
            this.ensurePlaceholders( view );

            // If we are using a time_only date_mode, then hide the date input.
            if ( 'undefined' != typeof view.model.get( 'date_mode' ) && 'time_only' == view.model.get( 'date_mode' ) ) {
                jQuery( el ).hide();
                return false;
            }

            // Make sure date format is correctly converted.
            var dateFormat = this.convertDateFormat( view.model.get( 'date_format' ) );
            // Make sure this is a deep conversion of the original model.
            view.model.set('date_format', dateFormat);

            var dateSettings = {
                onReady: ( selectedDates, datestr, dateObject ) => {
                    dateObject.altInput.setAttribute( 'aria-labelledby', jQuery( el ).attr( "aria-labelledby" ) );
                    dateObject.altInput.setAttribute( 'aria-invalid', false );
                },
                // E2E instrumentation (issue #7973): stamp a format-independent ISO date
                // (YYYY-MM-DD) on every day cell so automated tests can target a date
                // deterministically, regardless of the field's display date_format. The
                // aria-label follows the display format and is therefore not a stable hook.
                onDayCreate: ( selectedDates, dateStr, dateObject, dayElem ) => {
                    if ( dayElem && dayElem.dateObj ) {
                        const d = dayElem.dateObj;
                        const iso = d.getFullYear() + '-' +
                            ( '0' + ( d.getMonth() + 1 ) ).slice( -2 ) + '-' +
                            ( '0' + d.getDate() ).slice( -2 );
                        dayElem.setAttribute( 'data-qa-date', iso );
                    }
                },
                dateFormat: dateFormat,
                altFormat: dateFormat,
                altInput: true,
                ariaDateFormat: dateFormat,
                mode: "single",
                allowInput: true,
                disableMobile: "true",
                minDate: this.getMinDate(view.model),
                maxDate: this.getMaxDate(view.model),
            };
            
            const nfCustomLocale = this.checkCustomLocale();
            if(nfCustomLocale){
                dateSettings.locale = nfCustomLocale;
            }

            // Filter our datepicker settings object.
            let filteredDatePickerSettings = nfRadio.channel( 'flatpickr' ).request( 'filter:settings', dateSettings, view );
            if ( 'undefined' != typeof filteredDatePickerSettings ) {
                dateSettings = filteredDatePickerSettings;
            }

            // Fix for repeater fields: If value is in our custom object format (from validation),
            // temporarily convert it to just the date string for flatpickr initialization
            var currentValue = view.model.get( 'value' );
            var needsRestore = false;
            var fullValue = null;
            if ( _.isObject( currentValue ) && currentValue.date ) {
                // Store the full object and temporarily set just the date
                fullValue = currentValue;
                view.model.set( 'value', currentValue.date, { silent: true } );
                // Also update the DOM input element so flatpickr doesn't try to parse the object
                jQuery( el ).val( currentValue.date );
                needsRestore = true;
            }

            var dateObject = flatpickr( el, dateSettings );

            // Restore the full object value and set the date in flatpickr if we converted it
            if ( needsRestore ) {
                // Set the date directly in flatpickr
                // Convert string to Date object and trigger onChange (true) to update altInput display
                try {
                    var dateObj = new Date( fullValue.date );
                    dateObject.setDate( dateObj, true );
                } catch ( error ) {
                }
                view.model.set( 'value', fullValue, { silent: true } );
            }
            // Set default value only when value is missing
            if ( 1 == view.model.get( 'date_default' ) && ! view.model.get( 'value' ) ) {
                dateObject.defaultDate = new Date();
                dateObject.setDate(dateObject.defaultDate);
                view.model.set( 'value', flatpickr.formatDate( dateObject.defaultDate, dateFormat ), { silent: true } );
            }
            // Set default value in RFF context, only if value equals today's date
            if( 1 == view.model.get( 'date_default' ) &&
                typeof view.model.get('id') === "string" &&
                view.model.get('id').includes('.') &&
                typeof view.model.get( 'value' ) === "object" &&
                this.isSameDay( view.model.get( 'value' ), new Date() )
            ) {
                dateObject.defaultDate = new Date();
                dateObject.setDate(dateObject.defaultDate, true);
                view.model.set( 'value', flatpickr.formatDate( dateObject.defaultDate, dateFormat ), { silent: true } );
            }

            //Trigger Pikaday backwards compatibility
            nfRadio.channel( 'pikaday-bc' ).trigger( 'init', dateObject, view.model, view );

            nfRadio.channel( 'flatpickr' ).trigger( 'init', dateObject, view.model, view );
        },

        ensurePlaceholders: function( view ) {
            // Only add placeholders for time_only and date_and_time modes
            var dateMode = view.model.get( 'date_mode' );
            if ( 'date_only' === dateMode ) {
                return;
            }

            var self = this;

            // Diagnostic logging for repeater fields
            var fieldID = view.model.get( 'id' );
            var isRepeaterField = typeof fieldID === 'string' && fieldID.includes( '.' );

            // Use setTimeout to ensure DOM is fully rendered
            setTimeout( function() {
                var viewEl = jQuery( view.el );


                // Check and add placeholder to hour dropdown if missing
                var hourSelect = viewEl.find( '.hour' );

                if ( hourSelect.length > 0 ) {
                    var firstHourOption = hourSelect.find( 'option:first' );

                    var hasPlaceholder = firstHourOption.length > 0 && firstHourOption.val() === '';

                    if ( ! hasPlaceholder ) {
                        // Check if model has an hour value before resetting
                        var modelValue = view.model.get( 'value' );
                        var savedHour = null;

                        // Handle both object format (date_and_time) and string format (time_only)
                        if ( _.isObject( modelValue ) && modelValue.hour ) {
                            savedHour = modelValue.hour;
                        } else if ( _.isString( modelValue ) && modelValue.trim() !== '' ) {
                            // Parse string format like "03:30 pm"
                            var timeParts = modelValue.split( ':' );
                            if ( timeParts.length > 0 ) {
                                savedHour = timeParts[0].trim();
                            }
                        }

                        // Remove selected attribute from all options first
                        hourSelect.find( 'option' ).removeAttr( 'selected' );
                        // Prepend placeholder - don't disable it so it can be programmatically selected
                        var hourPlaceholderText = nfi18n.hourPlaceholder ? nfi18n.hourPlaceholder : 'Hour';
                        hourSelect.prepend( '<option value="" selected style="display:none;">' + hourPlaceholderText + '</option>' );
                        // Restore the hour value from model if it exists, otherwise show placeholder
                        if ( savedHour ) {
                            hourSelect.val( savedHour );
                        } else {
                            hourSelect.val( '' );
                        }
                    } else {
                    }

                    // Add change handler to trigger validation
                    hourSelect.off( 'change.nfDateValidation' ).on( 'change.nfDateValidation', function() {

                        // Update the model value with current dropdown values BEFORE validation
                        var currentHour = viewEl.find( '.hour' ).val();
                        var currentMinute = viewEl.find( '.minute' ).val();
                        var currentAmpm = viewEl.find( '.ampm' ).val();
                        var currentValue = view.model.get( 'value' );
                        var currentDate = '';

                        if ( _.isObject( currentValue ) ) {
                            currentDate = currentValue.date;
                        } else {
                            currentDate = currentValue;
                        }

                        var updatedValue = {
                            date: currentDate,
                            hour: currentHour,
                            minute: currentMinute,
                            ampm: currentAmpm
                        };

                        view.model.set( 'value', updatedValue );

                        // validateModelData() skips re-validating fields that already have a
                        // required-error, so the change:value trigger below can't clear this
                        // error once it's showing. Clear it explicitly once date, hour, and
                        // minute are all set (mirrors the time_only fix in changeDate.js).
                        if ( currentDate && currentHour && currentMinute ) {
                            nfRadio.channel( 'fields' ).request( 'remove:error', view.model.get( 'id' ), 'required-error' );
                        }

                        // Trigger change event on the model to re-run validation
                        view.model.trigger( 'change:value', view.model );
                        // Also trigger blur to ensure validation runs
                        nfRadio.channel( 'date' ).trigger( 'blur:field', view.el, view.model );
                    });
                }

                // Check and add placeholder to minute dropdown if missing
                var minuteSelect = viewEl.find( '.minute' );

                if ( minuteSelect.length > 0 ) {
                    var firstMinuteOption = minuteSelect.find( 'option:first' );

                    var hasPlaceholder = firstMinuteOption.length > 0 && firstMinuteOption.val() === '';

                    if ( ! hasPlaceholder ) {
                        // Check if model has a minute value before resetting
                        var modelValue = view.model.get( 'value' );
                        var savedMinute = null;

                        // Handle both object format (date_and_time) and string format (time_only)
                        if ( _.isObject( modelValue ) && modelValue.minute ) {
                            savedMinute = modelValue.minute;
                        } else if ( _.isString( modelValue ) && modelValue.trim() !== '' ) {
                            // Parse string format like "03:30 pm"
                            var timeParts = modelValue.split( ':' );
                            if ( timeParts.length > 1 ) {
                                var minuteAndAmpm = timeParts[1].trim().split( ' ' );
                                savedMinute = minuteAndAmpm[0];
                            }
                        }

                        // Remove selected attribute from all options first
                        minuteSelect.find( 'option' ).removeAttr( 'selected' );
                        // Prepend placeholder - don't disable it so it can be programmatically selected
                        var minutePlaceholderText = nfi18n.minutePlaceholder ? nfi18n.minutePlaceholder : 'Minute';
                        minuteSelect.prepend( '<option value="" selected style="display:none;">' + minutePlaceholderText + '</option>' );
                        // Restore the minute value from model if it exists, otherwise show placeholder
                        if ( savedMinute ) {
                            minuteSelect.val( savedMinute );
                        } else {
                            minuteSelect.val( '' );
                        }
                    } else {
                        // Even if placeholder exists, we need to set the correct value
                        // Check if model has a minute value, if not set to empty (placeholder)
                        var modelValue = view.model.get( 'value' );
                        var savedMinute = null;

                        // Handle both object format (date_and_time) and string format (time_only)
                        if ( _.isObject( modelValue ) && modelValue.minute ) {
                            savedMinute = modelValue.minute;
                        } else if ( _.isString( modelValue ) && modelValue.trim() !== '' ) {
                            // Parse string format like "03:30 pm"
                            var timeParts = modelValue.split( ':' );
                            if ( timeParts.length > 1 ) {
                                var minuteAndAmpm = timeParts[1].trim().split( ' ' );
                                savedMinute = minuteAndAmpm[0];
                            }
                        }

                        // Set to saved value or empty string for placeholder
                        if ( savedMinute ) {
                            minuteSelect.val( savedMinute );
                        } else {
                            minuteSelect.val( '' );
                        }
                    }

                    // Restore AM/PM value for time_only mode
                    var ampmSelect = viewEl.find( '.ampm' );
                    if ( ampmSelect.length > 0 ) {
                        var modelValue = view.model.get( 'value' );
                        var savedAmpm = null;

                        // Handle both object format (date_and_time) and string format (time_only)
                        if ( _.isObject( modelValue ) && modelValue.ampm ) {
                            savedAmpm = modelValue.ampm;
                        } else if ( _.isString( modelValue ) && modelValue.trim() !== '' ) {
                            // Parse string format like "03:30 pm"
                            var timeParts = modelValue.split( ' ' );
                            if ( timeParts.length > 1 ) {
                                savedAmpm = timeParts[1].trim().toLowerCase();
                            }
                        }

                        // Restore the ampm value if it exists
                        if ( savedAmpm ) {
                            ampmSelect.val( savedAmpm );
                        }
                    }

                    // Add change handler to trigger validation
                    minuteSelect.off( 'change.nfDateValidation' ).on( 'change.nfDateValidation', function() {

                        // Update the model value with current dropdown values BEFORE validation
                        var currentHour = viewEl.find( '.hour' ).val();
                        var currentMinute = viewEl.find( '.minute' ).val();
                        var currentAmpm = viewEl.find( '.ampm' ).val();
                        var currentValue = view.model.get( 'value' );
                        var currentDate = '';

                        if ( _.isObject( currentValue ) ) {
                            currentDate = currentValue.date;
                        } else {
                            currentDate = currentValue;
                        }

                        var updatedValue = {
                            date: currentDate,
                            hour: currentHour,
                            minute: currentMinute,
                            ampm: currentAmpm
                        };

                        view.model.set( 'value', updatedValue );

                        // validateModelData() skips re-validating fields that already have a
                        // required-error, so the change:value trigger below can't clear this
                        // error once it's showing. Clear it explicitly once date, hour, and
                        // minute are all set (mirrors the time_only fix in changeDate.js).
                        if ( currentDate && currentHour && currentMinute ) {
                            nfRadio.channel( 'fields' ).request( 'remove:error', view.model.get( 'id' ), 'required-error' );
                        }

                        // Trigger change event on the model to re-run validation
                        view.model.trigger( 'change:value', view.model );
                        // Also trigger blur to ensure validation runs
                        nfRadio.channel( 'date' ).trigger( 'blur:field', view.el, view.model );
                    });
                }
            }, 100 ); // Small delay to ensure template has rendered
        },

        beforeSubmit: function( formModel ) {
            //Get value from input if the default date wasn't edited in the field and the value is still a global unformatted date object
            if( _.isObject( this.model.get( 'value' ) ) ){
                // We detect the flatpickr input inside the element by its type instead of ID as the dot in the repeater children ID is not compatible with query selector
                const date_value = this.el.querySelector("input[type='hidden']").value;
                // silent: true - this is a transitional value (date only, no time yet) on
                // the way to being rebuilt into the full {date, hour, minute, ampm} object
                // a few lines below. Without silent, this fires a real validation pass on a
                // momentarily time-less value, which incorrectly fails (and sticks) for any
                // date_and_time field whose beforeSubmit runs after isSubmitting has been
                // set true by the first date field's beforeSubmit on the form.
                this.model.set( 'value', date_value, { silent: true } );
            }
            //Detect repeater and set data at the repeater level
            const inputID = this.el.dataset.fieldId;
            if(inputID.search(".") !== -1){
                nfRadio.channel('field-repeater').trigger('set:value');
                // Don't convert string value into object for time_only type in repeatable fieldset field
                if(this.model.get( 'date_mode' ) === "time_only"){
                    return;
                }
            }

            if ( 'date_only' == this.model.get( 'date_mode' ) ) {
                return false;
            }
            let hour = jQuery( this.el ).find( '.hour' ).val();
            let minute = jQuery( this.el ).find( '.minute' ).val();
            let ampm = jQuery( this.el ).find( '.ampm' ).val();
            let current_value = this.model.get( 'value' );
            let date = false;

            if ( _.isObject( current_value ) ) {
                date = current_value.date;
            } else {
                date = current_value;
            }

            // Convert empty string placeholders to empty values for validation
            if ( hour === '' ) hour = '';
            if ( minute === '' ) minute = '';

            let date_value = {
                date: date,
                hour: hour,
                minute: minute,
                ampm: ampm,
            };

            this.model.set( 'value', date_value );
        },

        getMinDate: function( fieldModel ) {
            let minDate = null;
            if(typeof fieldModel.get( 'year_range_start' ) !== "undefined"){
                const yearRangeStart = fieldModel.get( 'year_range_start' );
                if( yearRangeStart ) {
                    minDate = flatpickr.formatDate(new Date(String( yearRangeStart )), fieldModel.get('date_format'));
                }
            } 
            return minDate;
        },

        getMaxDate: function( fieldModel ) {
            let maxDate = null;
            if(typeof fieldModel.get( 'year_range_end' ) !== "undefined"){
                const yearRangeEnd = fieldModel.get( 'year_range_end' );
                if( yearRangeEnd ) {
                    maxDate = flatpickr.formatDate(new Date(String( yearRangeEnd )), fieldModel.get('date_format'));
                }
            }
            return maxDate;
        },

        convertDateFormat: function( dateFormat ) {
            //If dateFormat is empty or null, try to get a value from the Field's model
            if(!dateFormat && this.model){
                dateFormat = this.model.get('date_format');
            } 
            //If it is still empty or null set it to be "default"
            if (!dateFormat){
                dateFormat = "default";
            }
            //Convert PHP format in setting to flatPickr expected setting if needed
            const lookup = {
                'MM/DD/YYYY': 'm/d/Y',
                'MM-DD-YYYY': 'm-d-Y',
                'MM.DD.YYYY': 'm.d.Y',
                'DD/MM/YYYY': 'd/m/Y',
                'DD-MM-YYYY': 'd-m-Y',
                'DD.MM.YYYY': 'd.m.Y',
                'YYYY-MM-DD': 'Y-m-d',
                'YYYY/MM/DD': 'Y/m/d',
                'YYYY.MM.DD': 'Y.m.d',
                'dddd, MMMM D YYYY': 'l, F d Y',
                'default': nfi18n.dateFormat ? nfi18n.dateFormat : 'default'
            };
            return Object.keys(lookup).includes(dateFormat) ? lookup[dateFormat] : dateFormat;
        },

        customClasses: function( classes ) {
            if ( 'date_and_time' == this.date_mode ) {
                classes += ' date-and-time';
            }
            return classes;
        },
        //retrieve localized values and assign them to flatpickr locale format
        checkCustomLocale: function() {
            let customLocale = {};
            if(nfi18n){
                if(nfi18n.months || nfi18n.monthsShort){
                    customLocale.months = {};
                    if(nfi18n.months){
                        customLocale.months.longhand = nfi18n.months;
                    }
                    if(nfi18n.monthsShort){
                        customLocale.months.shorthand = nfi18n.monthsShort;
                    }
                }
                if(nfi18n.weekdays || nfi18n.weekdaysShort){
                    customLocale.weekdays = {};
                    if(nfi18n.weekdays){
                        customLocale.weekdays.longhand = nfi18n.weekdays;
                    }
                    if(nfi18n.weekdaysShort){
                        customLocale.weekdays.shorthand = nfi18n.weekdaysShort;
                    }
                }
                if(nfi18n.startOfWeek){
                    customLocale.firstDayOfWeek = nfi18n.startOfWeek;
                }
            }
            return _.isEmpty(customLocale) ? false : customLocale;
        },

        // This function is called whenever we want to know the value of the date field.
        // Since it could be a date/time field, we can't return just the value.
        getValue: function() {

            if ( 'date_only' == this.get( 'date_mode' ) ) {
                return this.get( 'value' );
            }
            let el = this.get( 'el' );
            let hour = jQuery( el ).find( '.hour' ).val();
            let minute = jQuery( el ).find( '.minute' ).val();
            let ampm = jQuery( el ).find( '.ampm' ).val();
            let current_value = this.get( 'value' );
            let date = false;


            if ( _.isObject( current_value ) ) {
                date = current_value.date;
            } else {
                date = current_value;
            }

            // Check if hour or minute are empty/invalid (empty string, null, or undefined)
            let hasValidHour = hour && hour !== '';
            let hasValidMinute = minute && minute !== '';


            // For time_only mode, BOTH hour AND minute must be selected
            if ( 'time_only' == this.get( 'date_mode' ) ) {
                // Return empty string if either hour or minute is missing
                if ( ! hasValidHour || ! hasValidMinute ) {
                    return '';
                }
                // Both are valid, return the time value
                let timeValue = hour + ':' + minute;
                if ( ampm ) {
                    timeValue += ' ' + ampm;
                }
                return timeValue;
            }

            // For date_and_time mode, only include time if BOTH hour AND minute are selected
            let value = '';

            if ( 'undefined' != typeof date && date ) {
                value += date;
            }

            // Only add time if both hour and minute are valid
            if ( hasValidHour && hasValidMinute ) {
                value += ' ' + hour + ':' + minute;
                if ( ampm ) {
                    value += ' ' + ampm;
                }
            }

            return value;

            // let date_value = {
            //     date: date,
            //     hour: hour,
            //     minute: minute,
            //     ampm: ampm,
            // };

            // this.model.set( 'value', date_value );
        },

        isSameDay: function(date1, date2) {
            const d1 = new Date(date1);
            const d2 = new Date(date2);
            d1.setHours(0, 0, 0, 0);
            d2.setHours(0, 0, 0, 0);
            return d1.getTime() === d2.getTime();
        },

        validateRequired: function( el, model ) {
            var dateMode = model.get( 'date_mode' );

            // For date_only mode, use default validation
            if ( 'date_only' === dateMode ) {
                return undefined; // Let default validation handle it
            }

            // For time_only and date_and_time modes, never flag the required
            // error from a single sub-input's blur/change - only a genuine
            // validation attempt (form submit, or "Next" on a validated
            // multi-part) should do that. validateModelData() below handles
            // that check, gated on this.isSubmitting.
            return true;
        },

        validateModelData: function( model ) {
            var fieldID = model.get( 'id' );
            var isRepeaterField = typeof fieldID === 'string' && fieldID.includes( '.' );

            var dateMode = model.get( 'date_mode' );

            // For date_only mode, use default validation
            if ( 'date_only' === dateMode ) {
                return undefined;
            }

            // Get the model value
            var value = model.get( 'value' );

            // For time_only, check if we have a valid time
            if ( 'time_only' === dateMode ) {
                // Value can be either an object (from change handlers) or string (from beforeSubmit)
                if ( _.isObject( value ) ) {
                    // Object format: {date: '', hour: '12', minute: '00', ampm: 'pm'}
                    var hasHour = value.hour && value.hour !== '' && value.hour !== 'null';
                    var hasMinute = value.minute && value.minute !== '' && value.minute !== 'null' && value.minute !== null;


                    // If both are empty, check if we're submitting
                    if ( ! hasHour && ! hasMinute ) {
                        if ( this.isSubmitting ) {
                            return false;
                        } else {
                            return true;
                        }
                    }

                    // If partially filled, check submit state
                    if ( this.isSubmitting ) {
                        // During submit, both must be filled
                        var isValid = hasHour && hasMinute;
                        return isValid;
                    } else {
                        // During field interaction, allow partial fill
                        return true;
                    }
                }

                // String format: "12:00 pm"
                // Value should be a string like "12:00 pm" or empty
                // Check if it's not just ":null pm" or ": pm" or similar invalid formats
                if ( ! value || value.trim() === '' ) {
                    return false;
                }

                // Parse the time value to check if hour and minute are valid
                // Format is typically "HH:MM" or "HH:MM am/pm"
                var timeParts = value.split( ':' );
                var hour = timeParts[0] ? timeParts[0].trim() : '';
                var minutePart = timeParts[1] ? timeParts[1].trim().split( ' ' )[0] : '';

                // Check if hour is valid (not empty, not "null", not just whitespace)
                var hasValidHour = hour && hour !== '' && hour !== 'null' && ! isNaN( parseInt( hour ) );
                var hasValidMinute = minutePart && minutePart !== '' && minutePart !== 'null' && ! isNaN( parseInt( minutePart ) );

                // If both are empty, check if we're submitting
                if ( ! hasValidHour && ! hasValidMinute ) {
                    if ( this.isSubmitting ) {
                        return false;
                    } else {
                        return true;
                    }
                }

                // If partially filled, check submit state (mirrors the object-format branch above)
                if ( this.isSubmitting ) {
                    var isValid = hasValidHour && hasValidMinute;
                    return isValid;
                } else {
                    return true;
                }
            }

            // For date_and_time mode during validation
            // The value might be an object or string
            if ( _.isObject( value ) ) {
                var hasDate = value.date && value.date.trim() !== '';
                var hasHour = value.hour && value.hour !== '' && value.hour !== 'null';
                var hasMinute = value.minute && value.minute !== '' && value.minute !== 'null' && value.minute !== null;

                // If no date, fail
                if ( ! hasDate ) {
                    return false;
                }

                // If both time fields are empty, check if we're submitting
                if ( ! hasHour && ! hasMinute ) {
                    // During submit, require time. During field interaction, allow.
                    if ( this.isSubmitting ) {
                        return false;
                    } else {
                        return true;
                    }
                }

                // If time is partially filled, check submit state
                // At least one time field is filled if we reach here
                if ( this.isSubmitting ) {
                    // During submit, both must be filled
                    var isValid = hasHour && hasMinute;
                    return isValid;
                } else {
                    // During field interaction, allow partial fill (user is still filling out)
                    return true;
                }
            }

            // String value - parse it to check for both date and time
            if ( value && value.trim() !== '' ) {
                // If it contains a colon, it should have time
                if ( value.indexOf( ':' ) > -1 ) {
                    // Parse to ensure valid time
                    var parts = value.split( ' ' );
                    var datePart = parts[0];
                    var timePart = parts[1];

                    if ( ! datePart || ! timePart ) {
                        return false;
                    }

                    var timeComponents = timePart.split( ':' );
                    var hour = timeComponents[0];
                    var minute = timeComponents[1] ? timeComponents[1].split( ' ' )[0] : '';

                    var hasValidHour = hour && hour !== '' && hour !== 'null' && ! isNaN( parseInt( hour ) );
                    var hasValidMinute = minute && minute !== '' && minute !== 'null' && ! isNaN( parseInt( minute ) );

                    // If both are empty, fail regardless of submit state
                    if ( ! hasValidHour && ! hasValidMinute ) {
                        return false;
                    }

                    // If partially filled, check submit state (mirrors the object-format branch above)
                    if ( this.isSubmitting ) {
                        return hasValidHour && hasValidMinute;
                    } else {
                        return true;
                    }
                }

                // No colon means no time in the string value
                // During submit, this is invalid. During field interaction, allow it.
                if ( this.isSubmitting ) {
                    return false;
                } else {
                    return true;
                }
            }

            return false;
        }

    });

    return controller;
});

